import {
	Contacts,
	ContactsContainer,
	CustomSwiperSlide,
	Section,
	SectionHeading,
} from "./styles";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper } from "swiper/react";
import { Link } from "react-router-dom";

const ContactsSection = () => {
	return (
		<Section>
			<SectionHeading>
				<Swiper
					loop={true}
					autoplay={{
						delay: 0,
						disableOnInteraction: false,
					}}
					effect={"fade"}
					speed={10000}
					modules={[FreeMode, Autoplay]}
					spaceBetween={40}
					slidesPerView="auto"
					navigation
					className={"eachSlide swiper-no-swiping"}
				>
					<CustomSwiperSlide black={"true"}>
						<span>Contact us</span>
					</CustomSwiperSlide>

					<CustomSwiperSlide gray={"true"}>
						<span>Contact us</span>
					</CustomSwiperSlide>
				</Swiper>
			</SectionHeading>
			<ContactsContainer>
				<Contacts>
					<h6>Visit us</h6>
					<p>
						Yerevan, Armenia
					</p>
					<Link to="https://www.google.com/maps/place/Yerevan/@40.1533904,44.4885671,12z" target="_blank">
						Get Directions
					</Link>
				</Contacts>
				<Contacts>
					<h6>Email us</h6>
					<p>General</p>
					<Link to="mailto:info@spesna.com">info@spesna.com</Link>
				</Contacts>
				<Contacts>
					<h6>Call us</h6>
					<p>Phone</p>
					<Link to="tel:+37477733373">+374 77 73 33 73</Link>
				</Contacts>
			</ContactsContainer>
		</Section>
	);
};

export default ContactsSection;
